import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/business-directory/categories")({
  component: RouteComponent,
  loader: async ({ location }) => {
    // If accessing the route directly without query parameters, redirect to business directory
    if (!location.search) {
      throw redirect({
        to: "/business-directory",
      });
    }
    return {
      crumb: "Categories",
      crumbTo: "/business-directory",
    };
  },
});

function RouteComponent() {
  return <Outlet />;
}
